import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 825;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = '4240c847-1295-468d-a6ce-6353e2fe8024-825';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();
